import React from 'react';
import './styles.css';

const Features = () => {
  const data = {
    heading: 'Funcionalidades que te ayudan a crecer',
    headingText: 'Descubrí todas las herramientas que tenemos para vos',
    workData: [
      {
        id: 1,
        iconClass: 'fas fa-mobile-alt',
        text: 'Carta digital accesible desde cualquier dispositivo',
      },
      {
        id: 2,
        iconClass: 'fas fa-shopping-cart',
        text: 'Sistema de pedidos integrado',
      },
      {
        id: 3,
        iconClass: 'fas fa-chart-line',
        text: 'Analíticas para mejorar tu negocio',
      },
    ],
  };

  return (
    <section id="features-section" className="section features-area bg-overlay" style={{ padding: '100px 0' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-6">
            <div className="section-title text-center">
              <h2 className="text-white">{data.heading}</h2>
              <p className="text-white">{data.headingText}</p>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: '50px' }}>
          {data.workData.map((item, key) => (
            <div key={key} className="col-12 col-md-4">
              <div className="features-item text-center">
                <div
                  className="icon"
                  style={{
                    fontSize: '2rem',
                    marginBottom: '1.5rem',
                    width: '80px',
                    height: '80px',
                    backgroundColor: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 1.5rem',
                    borderRadius: '0 15px 15px 15px'
                  }}
                >
                  <i className={item.iconClass} style={{ color: '#FFA500' }} />
                </div>
                <h3 className="text-white" style={{ fontSize: '1.2rem' }}>{item.text}</h3>
              </div>
            </div>
          ))}
        </div>
        <div className="row justify-content-center mt-5">
          <div className="col-12 text-center">
            <a href="#how-it-works" className="scroll" style={{
              backgroundColor: 'white',
              color: '#F9B900',
              borderRadius: '30px',
              padding: '12px 30px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              display: 'inline-block',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              border: 'none'
            }}>Descubrí más</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features; 